import { useState, useRef, useEffect, useCallback } from "react";

const KB = [
  { kw: ["download ea investor","ea investor","investor mt5","investor mt4"],
    title: { id:"Download EA Investor", en:"Download EA Investor" },
    body:  { id:"EA Investor v4.2 tersedia untuk MT5 (.ex5) dan MT4 (.ex4).", en:"EA Investor v4.2 available for MT5 (.ex5) and MT4 (.ex4)." },
    actions: [
      { label:{ id:"EA Investor MT5 (.ex5)", en:"EA Investor MT5 (.ex5)" }, href:"/api/ea/download/investor-mt5" },
      { label:{ id:"EA Investor MT4 (.ex4)", en:"EA Investor MT4 (.ex4)" }, href:"/api/ea/download/investor-mt4" },
    ],
  },
  { kw: ["download ea publisher","ea publisher","ea trader","publisher mt5","publisher mt4"],
    title: { id:"Download EA Publisher (Trader)", en:"Download EA Publisher (Trader)" },
    body:  { id:"EA Publisher v4.1 tersedia untuk MT5 dan MT4.", en:"EA Publisher v4.1 available for MT5 and MT4." },
    actions: [
      { label:{ id:"EA Publisher MT5 (.ex5)", en:"EA Publisher MT5 (.ex5)" }, href:"/api/ea/download/mt5" },
      { label:{ id:"EA Publisher MT4 (.ex4)", en:"EA Publisher MT4 (.ex4)" }, href:"/api/ea/download/mt4" },
    ],
  },
  { kw: ["install ea","pasang ea","cara install","setup ea","mql5","mql4","experts folder"],
    title: { id:"Cara Install EA di MetaTrader", en:"How to Install EA in MetaTrader" },
    body:  { id:"1. Buka MetaTrader → File → Open Data Folder\n2. Copy .ex5 ke MQL5/Experts/ (MT5) atau MQL4/Experts/ (MT4)\n3. Restart MetaTrader\n4. Drag EA dari Navigator ke chart\n5. Enable AutoTrading di toolbar MT", en:"1. Open MetaTrader → File → Open Data Folder\n2. Copy .ex5 to MQL5/Experts/ (MT5) or MQL4/Experts/ (MT4)\n3. Restart MetaTrader\n4. Drag EA from Navigator to any chart\n5. Enable AutoTrading in MT toolbar" },
  },
  { kw: ["ea key","api key","generate key","kunci ea"],
    title: { id:"EA Key", en:"EA Key" },
    body:  { id:"EA Key di-generate per akun broker:\n• Investor: Settings → EA Key per Account → Generate Key\n• Trader: Dashboard → Accounts → EA Setup → Generate EA Key\n\nCopy-paste key ke input API Key di EA MetaTrader.", en:"EA Key is generated per broker account:\n• Investor: Settings → EA Key per Account → Generate Key\n• Trader: Dashboard → Accounts → EA Setup → Generate EA Key\n\nCopy-paste the key to API Key input in MetaTrader EA." },
  },
  { kw: ["server url","url server","endpoint","crunchalpha.com"],
    title: { id:"Server URL", en:"Server URL" },
    body:  { id:"Server URL untuk semua EA:\nhttps://crunchalpha.com\n\nMasukkan di setting EA saat attach ke chart.", en:"Server URL for all EAs:\nhttps://crunchalpha.com\n\nEnter this in EA settings when attaching to chart." },
  },
  { kw: ["autotrading","auto trading","enable autotrading"],
    title: { id:"Enable AutoTrading", en:"Enable AutoTrading" },
    body:  { id:"Setelah attach EA ke chart:\n1. Klik tombol AutoTrading di toolbar MT\n2. Pastikan ikon berubah jadi hijau/aktif\n3. EA mulai terkoneksi ke CrunchAlpha", en:"After attaching EA to chart:\n1. Click AutoTrading button in MT toolbar\n2. Make sure the icon turns green/active\n3. EA starts connecting to CrunchAlpha" },
  },
  { kw: ["alpharank","alpha rank","alpha score","skor","grade","pilar","pillar"],
    title: { id:"AlphaRank & AlphaScore", en:"AlphaRank & AlphaScore" },
    body:  { id:"AlphaScore dihitung dari 7 Pilar:\nP1 Profitability — total keuntungan bersih\nP2 Consistency — konsistensi return dari waktu ke waktu\nP3 Risk Management — disiplin SL/TP & risk flags\nP4 Recovery Resilience — kecepatan recovery dari drawdown\nP5 Trading Edge — ekspektansi & edge score\nP6 Discipline — menghindari revenge trading\nP7 Track Record — jumlah trade & panjang histori\n\nGrade: A+≥90, A≥85, A-≥80, B+≥75, B≥70, B-≥65, C+≥60, C≥55, C-≥50, D≥40, F<40", en:"AlphaScore is calculated from 7 Pillars:\nP1 Profitability — total net profit\nP2 Consistency — return consistency over time\nP3 Risk Management — SL/TP discipline & risk flags\nP4 Recovery Resilience — recovery speed from drawdown\nP5 Trading Edge — expectancy & edge score\nP6 Discipline — avoiding revenge trading\nP7 Track Record — trade count & history length\n\nGrade: A+≥90, A≥85, A-≥80, B+≥75, B≥70, B-≥65, C+≥60, C≥55, C-≥50, D≥40, F<40" },
  },
  { kw: ["flag","no stop loss","high drawdown","extreme position","peringatan"],
    title: { id:"AlphaRank Flags", en:"AlphaRank Flags" },
    body:  { id:"   No Stop Loss (MAJOR) — tidak pakai SL\n   High Drawdown (MAJOR) — DD > 20%\n   Extreme Position Sizing (MAJOR) — avg P&L/trade > 15%\n\nFlags MAJOR menurunkan AlphaScore signifikan.", en:"   No Stop Loss (MAJOR) — no SL used\n   High Drawdown (MAJOR) — DD > 20%\n   Extreme Position Sizing (MAJOR) — avg P&L/trade > 15%\n\nMAJOR flags significantly reduce AlphaScore." },
  },
  { kw: ["billing","fee","biaya","performance fee","subscription","hwm","basic","premium"],
    title: { id:"Billing & Subscription", en:"Billing & Subscription" },
    body:  { id:"Plan:\n• Basic $9.99/mo — 1 follower account, max 3 traders, max 3 signal sets\n• Premium $29.99/mo — unlimited semua, auto-rebalance, advanced analytics\n\nPerformance Fee: 25% of profit (HWM — bayar hanya dari profit baru)", en:"Plans:\n• Basic $9.99/mo — 1 follower account, max 3 traders, max 3 signal sets\n• Premium $29.99/mo — unlimited everything, auto-rebalance, advanced analytics\n\nPerformance Fee: 25% of profit (HWM — only charged on new profit)" },
    actions: [{ label:{ id:"Lihat Billing", en:"View Billing" }, href:"/investor/billing" }],
  },
  { kw: ["copy engine","max lot","max daily loss","max open trades","risk management"],
    title: { id:"Copy Engine Settings", en:"Copy Engine Settings" },
    body:  { id:"Investor Settings → Copy Engine:\n• Enable Copy Trader — mirror posisi trader\n• Enable Copy Analyst — auto-execute signal analyst\n• Max Lot Cap — safety limit per order\n• Max Daily Loss % — stop copy jika loss melebihi %\n• Max Open Trades — max posisi bersamaan per akun", en:"Investor Settings → Copy Engine:\n• Enable Copy Trader — mirror trader positions\n• Enable Copy Analyst — auto-execute analyst signals\n• Max Lot Cap — safety limit per order\n• Max Daily Loss % — stop copying if loss exceeds %\n• Max Open Trades — max simultaneous positions per account" },
  },
  { kw: ["copy trade","copy trading","ikut trader","subscribe trader"],
    title: { id:"Cara Copy Trade", en:"How to Copy Trade" },
    body:  { id:"1. Daftar sebagai Investor\n2. Add Account → Download EA Investor v4.2\n3. Install EA di MetaTrader\n4. Generate EA Key per akun\n5. Enable AutoTrading\n6. My Portfolio → Subscribe ke trader", en:"1. Register as Investor\n2. Add Account → Download EA Investor v4.2\n3. Install EA in MetaTrader\n4. Generate EA Key per account\n5. Enable AutoTrading\n6. My Portfolio → Subscribe to a trader" },
    actions: [{ label:{ id:"Browse Trader", en:"Browse Traders" }, href:"/marketplace" }],
  },
  { kw: ["signal set","buat signal","send signal","kirim signal","copy analyst"],
    title: { id:"Copy Analyst (Signal)", en:"Copy Analyst (Signal)" },
    body:  { id:"1. Add Account → Download EA Investor v4.2\n2. Install EA & Generate Key\n3. My Portfolio → Subscribe ke Signal Set analyst\n4. Settings → Copy Engine → Enable Copy Analyst", en:"1. Add Account → Download EA Investor v4.2\n2. Install EA & Generate Key\n3. My Portfolio → Subscribe to analyst Signal Set\n4. Settings → Copy Engine → Enable Copy Analyst" },
    actions: [{ label:{ id:"My Portfolio", en:"My Portfolio" }, href:"/investor" }],
  },
  { kw: ["add account","tambah akun","broker account","akun trading"],
    title: { id:"Tambah Akun Broker", en:"Add Broker Account" },
    body:  { id:"Investor: Settings → Broker Account → + Add Account\nTrader: Dashboard → Accounts → Add Account\n\nMasukkan: broker, platform (MT4/MT5), nomor akun.", en:"Investor: Settings → Broker Account → + Add Account\nTrader: Dashboard → Accounts → Add Account\n\nEnter: broker, platform (MT4/MT5), account number." },
  },
  { kw: ["cent account","cent","is_cent","akun cent","standard"],
    title: { id:"Akun Cent vs Standard", en:"Cent vs Standard Account" },
    body:  { id:"Saat add account, pilih tipe akun:\n• Standard — lot dalam USD normal\n• Cent — lot dalam cent (0.01× dari standard)\n\nPilih yang sesuai dengan tipe akun broker kamu.", en:"When adding account, select account type:\n• Standard — lot in normal USD\n• Cent — lot in cents (0.01× of standard)\n\nChoose according to your broker account type." },
  },
  { kw: ["live position","posisi live","open position"],
    title: { id:"Live Positions", en:"Live Positions" },
    body:  { id:"Tab Live Positions di Investor Dashboard: semua posisi OPENED/PENDING dari trader & analyst yang kamu follow — real-time.", en:"Live Positions tab in Investor Dashboard: all OPENED/PENDING positions from traders & analysts you follow — real-time." },
    actions: [{ label:{ id:"Investor Dashboard", en:"Investor Dashboard" }, href:"/investor" }],
  },
  { kw: ["copy history","signal history","riwayat copy","rejected"],
    title: { id:"Copy & Signal History", en:"Copy & Signal History" },
    body:  { id:"Tab Copy History → dua sub-tab:\n• Trader Copy History\n• Signal Copy History (termasuk REJECTED)\n\nCek di sini jika trade tidak ter-copy.", en:"Copy History tab → two sub-tabs:\n• Trader Copy History\n• Signal Copy History (including REJECTED)\n\nCheck here if trades are not being copied." },
    actions: [{ label:{ id:"Copy History", en:"Copy History" }, href:"/investor" }],
  },
  { kw: ["daftar","register","sign up","buat akun"],
    title: { id:"Cara Daftar", en:"How to Register" },
    body:  { id:"1. Buka https://crunchalpha.com\n2. Klik Register\n3. Isi email & password\n4. Pilih role: Investor, Trader, atau Analyst\n5. Verifikasi email", en:"1. Go to https://crunchalpha.com\n2. Click Register\n3. Enter email & password\n4. Choose role: Investor, Trader, or Analyst\n5. Verify email" },
    actions: [{ label:{ id:"Daftar Sekarang", en:"Register Now" }, href:"/register" }],
  },
  { kw: ["ghost position","posisi hantu","stale position"],
    title: { id:"Ghost Position", en:"Ghost Position" },
    body:  { id:"Ghost position (sudah tutup di trader tapi masih buka di akun kamu) rekonsiliasi otomatis dalam 1-2 menit. Jika > 5 menit, hubungi support.", en:"Ghost positions (closed at trader but still open in your account) auto-reconcile within 1-2 minutes. If > 5 minutes, contact support." },
  },

  { kw: ["risk normalization","aum","lot sizing","lot size","lot otomatis","aum-based","risk control","normalisasi"],
    title: { id:"Risk Normalization (AUM-based Lot Sizing)", en:"Risk Normalization (AUM-based Lot Sizing)" },
    body: { 
      id:"CrunchAlpha otomatis menyesuaikan lot size berdasarkan modal kamu, bukan ikut lot provider.\n\nContoh:\n• Provider trading dengan modal $10.000, lot 1.0\n• Kamu hanya punya modal $1.000 (10% dari provider)\n• Sistem otomatis copy dengan lot 0.1 (10% dari 1.0)\n\nJadi risk kamu selalu proporsional dengan modal kamu — bukan ikut-ikutan lot besar provider.",
      en:"CrunchAlpha automatically adjusts lot size based on your capital, not the provider's lot.\n\nExample:\n• Provider trades with $10,000 capital, lot 1.0\n• You have $1,000 capital (10% of provider)\n• System auto-copies with lot 0.1 (10% of 1.0)\n\nYour risk is always proportional to your capital — never blindly following the provider's lot size."
    },
  },
  { kw: ["allocation","alokasi","berapa persen","% modal","position sizing","set allocation","alokasikan"],
    title: { id:"Allocation & Position Sizing", en:"Allocation & Position Sizing" },
    body: {
      id:"Allocation adalah % modal yang kamu dedikasikan untuk copy satu provider.\n\nPanduan umum (bukan saran investasi):\n• Conservative: max 20-30% per provider\n• Balanced: max 30-50% per provider\n• Jangan taruh semua modal ke 1 provider\n\nSistem akan menghitung lot size otomatis berdasarkan allocation yang kamu set.\n\nApakah ada yang masih bingung soal allocation?",
      en:"Allocation is the % of capital you dedicate to copying one provider.\n\nGeneral guidance (not investment advice):\n• Conservative: max 20-30% per provider\n• Balanced: max 30-50% per provider\n• Never put all capital into 1 provider\n\nThe system auto-calculates lot size based on your allocation.\n\nAny questions about allocation?"
    },
  },
  { kw: ["cara kerja","how it works","bagaimana cara","langkah","step","mulai","getting started","non-custodial"],
    title: { id:"Cara Kerja CrunchAlpha (3 Langkah)", en:"How CrunchAlpha Works (3 Steps)" },
    body: {
      id:"CrunchAlpha bekerja dalam 3 langkah sederhana:\n\n1. Pilih Provider\n   Browse trader/analyst di Marketplace berdasarkan AlphaRank™. Lihat ROI, Win Rate, Max DD, dan Risk Level.\n\n2. Set Allocation\n   Tentukan % modal yang ingin kamu alokasikan. Sistem otomatis hitung lot size.\n\n3. Copy Otomatis dengan Risk Control\n   EA Investor di MT kamu akan copy setiap trade secara real-time dengan lot yang sudah dinormalisasi.\n\nPlatform bersifat non-custodial — dana kamu tetap di akun broker kamu sendiri.",
      en:"CrunchAlpha works in 3 simple steps:\n\n1. Choose Provider\n   Browse traders/analysts on Marketplace by AlphaRank™. Check ROI, Win Rate, Max DD, and Risk Level.\n\n2. Set Allocation\n   Set the % of capital to allocate. System auto-calculates lot size.\n\n3. Auto Copy with Risk Control\n   EA Investor on your MT copies every trade in real-time with normalized lot sizes.\n\nNon-custodial — your funds stay in your own broker account."
    },
  },
  { kw: ["alpharank score","baca alpharank","cara baca","roi","win rate","max dd","risk level","consistency","skor bagus","skor buruk"],
    title: { id:"Cara Membaca AlphaRank™", en:"How to Read AlphaRank™" },
    body: {
      id:"AlphaRank™ menggabungkan 7 pilar menjadi 1 skor (0-100).\n\nCara baca:\n• Grade A (≥85): Track record kuat, risk terkelola\n• Grade B (70-84): Performa baik, risk sedang\n• Grade C (50-69): Performa cukup, perlu hati-hati\n• Grade D/F (<50): Hindari dulu\n\nPerhatikan juga:\n• Max DD: semakin kecil semakin baik\n• Risk Flags: jika ada flag MAJOR, pertimbangkan ulang\n• Risk Level: sesuaikan dengan profil risiko kamu\n\nApakah ada yang masih bingung cara memilih provider?",
      en:"AlphaRank™ combines 7 pillars into 1 score (0-100).\n\nHow to read:\n• Grade A (≥85): Strong track record, managed risk\n• Grade B (70-84): Good performance, moderate risk\n• Grade C (50-69): Decent, proceed with caution\n• Grade D/F (<50): Avoid for now\n\nAlso check:\n• Max DD: lower is better\n• Risk Flags: if MAJOR flags exist, reconsider\n• Risk Level: match with your risk profile\n\nAny questions on choosing a provider?"
    },
  },
  { kw: ["non custodial","dana aman","keamanan dana","fund safety","broker sendiri","apakah aman","aman tidak"],
    title: { id:"Keamanan Dana (Non-Custodial)", en:"Fund Safety (Non-Custodial)" },
    body: {
      id:"CrunchAlpha bersifat non-custodial — artinya:\n• Dana kamu TIDAK disimpan di CrunchAlpha\n• Dana tetap di akun broker kamu sendiri\n• CrunchAlpha hanya mengirim sinyal trade via EA\n• Kamu bisa stop copy kapan saja\n\nCrunchAlpha tidak bisa mengakses atau memindahkan dana kamu.",
      en:"CrunchAlpha is non-custodial — meaning:\n• Your funds are NOT held by CrunchAlpha\n• Funds stay in your own broker account\n• CrunchAlpha only sends trade signals via EA\n• You can stop copying anytime\n\nCrunchAlpha cannot access or move your funds."
    },
  },
  { kw: ["saran investasi","profit guaranteed","jaminan profit","pasti profit","rekomendasi provider","provider terbaik","mana yang bagus"],
    title: { id:"Saran Provider & Risiko", en:"Provider Advice & Risk" },
    body: {
      id:"CrunchAlpha tidak memberikan jaminan profit atau rekomendasi spesifik provider.\n\nYang bisa kami bantu:\n• Jelaskan cara membaca AlphaRank™\n• Bantu kamu memahami risk profile masing-masing provider\n• Guide cara set allocation yang aman\n\nKeputusan memilih provider sepenuhnya ada di tangan kamu berdasarkan data yang tersedia.\n\nMau belajar cara membaca AlphaRank™?",
      en:"CrunchAlpha does not guarantee profit or recommend specific providers.\n\nWhat we can help with:\n• Explain how to read AlphaRank™\n• Help you understand each provider's risk profile\n• Guide you on safe allocation setup\n\nThe decision to follow a provider is entirely yours based on available data.\n\nWant to learn how to read AlphaRank™?"
    },
  },

  { kw: ["signalsync","signal sync","plan trade","plan vs live","thesis"],
    title: { id:"SignalSync™ (Plan vs Live)", en:"SignalSync™ (Plan vs Live)" },
    body: {
      id:"SignalSync™ mengubah trade live trader menjadi signal plan (entry/SL/TP) yang bisa diikuti investor — thesis on record, terpisah dari eksekusi live.\n\nAktifkan di Trader Dashboard. Investor melihat plan di Marketplace berdampingan dengan live track record.",
      en:"SignalSync™ turns a trader's live trades into plan signals (entry/SL/TP) investors can follow — thesis on record, separate from live execution.\n\nEnable from Trader Dashboard. Investors see the plan on Marketplace side by side with the live track record."
    },
  },
  { kw: ["virtual score","virtual alpharank","analyst score","skor virtual"],
    title: { id:"Virtual Score (Analyst)", en:"Virtual Score (Analyst)" },
    body: {
      id:"Analyst tidak butuh akun live. AlphaScore dihitung dari sinyal tertutup (virtual equity, R-units) dengan formula yang sama seperti trader.\n\nMinimum ~20 closed signals. Skor di Overview dan kolom Virtual Score di Signal Sets memakai sumber virtual yang sama untuk set yang aktif.",
      en:"Analysts do not need a live account. AlphaScore is computed from closed signals (virtual equity, R-units) with the same formula as traders.\n\nAbout 20 closed signals minimum. Overview and the Signal Sets Virtual Score column use the same virtual source for the active set."
    },
  },
  { kw: ["marketplace","portfolio cart","add to portfolio","browse strategy"],
    title: { id:"Marketplace & Portfolio", en:"Marketplace & Portfolio" },
    body: {
      id:"Marketplace menampilkan trader live dan signal set analyst, diurutkan AlphaRank™.\n\nInvestor: + Add to Portfolio lalu subscribe. Trader/Analyst: Share & Earn untuk link affiliate.",
      en:"Marketplace lists live traders and analyst signal sets, ranked by AlphaRank™.\n\nInvestors: + Add to Portfolio then subscribe. Traders/Analysts: Share & Earn for affiliate links."
    },
    actions: [{ label:{ id:"Buka Marketplace", en:"Open Marketplace" }, href:"/marketplace" }],
  },
  { kw: ["affiliate","share earn","referral","komisi referral"],
    title: { id:"Affiliate / Share & Earn", en:"Affiliate / Share & Earn" },
    body: {
      id:"Bagikan link strategi/signal set dengan kode referral. Investor yang daftar lewat linkmu bisa menghasilkan komisi sesuai program affiliate.\n\nCek ringkasan di menu Affiliate / Earnings (sesuai role).",
      en:"Share a strategy or signal-set link with your referral code. Investors who join via your link can generate commission per the affiliate program.\n\nSee summary under Affiliate / Earnings (by role)."
    },
  },
  { kw: ["white label","partner","subdomain","branding"],
    title: { id:"White Label (Partner)", en:"White Label (Partner)" },
    body: {
      id:"Partner white-label memakai branding & subdomain sendiri di atas platform CrunchAlpha. Fitur core (AlphaRank, copy, signal) tetap sama.\n\nUntuk setup partner, hubungi tim CrunchAlpha.",
      en:"White-label partners run their own branding and subdomain on top of CrunchAlpha. Core features (AlphaRank, copy, signals) stay the same.\n\nContact the CrunchAlpha team for partner setup."
    },
  },
  { kw: ["role","trader investor analyst","ganti role","multiple role"],
    title: { id:"Roles (Investor / Trader / Analyst)", en:"Roles (Investor / Trader / Analyst)" },
    body: {
      id:"Satu akun punya primary role saat onboarding. Menu sidebar menyesuaikan role.\n• Investor — copy trader/analyst, portfolio, billing\n• Trader — connect MT, AlphaRank, followers, earnings\n• Analyst — signal sets, virtual score, subscribers\n\nMarketplace bisa diakses lintas role untuk browse.",
      en:"One account has a primary role at onboarding. Sidebar menus follow that role.\n• Investor — copy traders/analysts, portfolio, billing\n• Trader — connect MT, AlphaRank, followers, earnings\n• Analyst — signal sets, virtual score, subscribers\n\nMarketplace is available across roles for browsing."
    },
  },

];

const F = {
  root: {
    msgs: {
      id: ["Halo! Saya asisten CrunchAlpha.", "Saya bisa bantu kamu setup akun, EA, copy trade, dan lainnya.", "Kamu sebagai apa di CrunchAlpha?"],
      en: ["Hi! I'm the CrunchAlpha assistant.", "I can help you set up your account, EA, copy trading, and more.", "What is your role on CrunchAlpha?"],
    },
    chips: [
      { id:"Saya Investor", en:"I'm an Investor", next:"inv_home" },
      { id:"Saya Trader", en:"I'm a Trader", next:"tr_home" },
      { id:"Saya Analyst", en:"I'm an Analyst", next:"an_home" },
      { id:"Saya baru di sini", en:"I'm new here", next:"vis_home" },
    ],
  },

  /* ── INVESTOR ─────────────────────────────── */
  inv_home: {
    msgs: {
      id: ["Halo Investor!\n\nDi CrunchAlpha kamu bisa copy dari Trader, dari Analyst, atau keduanya.\n\nMau mulai dari mana?"],
      en: ["Hello Investor!\n\nOn CrunchAlpha you can copy from Traders, Analysts, or both.\n\nWhat would you like to do?"],
    },
    chips: [
      { id:"Setup Copy Trade (Trader)", en:"Setup Copy Trade (Trader)", next:"inv_copy_trader" },
      { id:"Setup Copy Signal (Analyst)", en:"Setup Copy Signal (Analyst)", next:"inv_copy_analyst" },
      { id:"Setup Keduanya", en:"Setup Both", next:"inv_copy_both" },
      { id:"Billing & Subscription", en:"Billing & Subscription", next:"inv_billing" },
      { id:"Troubleshoot", en:"Troubleshoot", next:"inv_trouble" },
    ],
  },
  inv_copy_trader: {
    msgs: {
      id: ["Copy Trader — kamu mirror posisi dari trader pilihan secara otomatis.\n\nFlow: Add Account → Download EA → Install → Generate Key → AutoTrading → Subscribe Trader\n\nMulai step 1?"],
      en: ["Copy Trader — you automatically mirror positions from your chosen trader.\n\nFlow: Add Account → Download EA → Install → Generate Key → AutoTrading → Subscribe Trader\n\nStart from step 1?"],
    },
    chips: [
      { id:"Mulai setup", en:"Start setup", next:"inv_add_account" },
      { id:"Kembali", en:"Back", next:"inv_home" },
    ],
  },
  inv_copy_analyst: {
    msgs: {
      id: ["Copy Analyst — EA kamu auto-execute signal dari analyst.\n\nFlow: Add Account → Download EA → Install → Generate Key → AutoTrading → Subscribe Signal Set\n\nMulai step 1?"],
      en: ["Copy Analyst — your EA auto-executes signals from analysts.\n\nFlow: Add Account → Download EA → Install → Generate Key → AutoTrading → Subscribe Signal Set\n\nStart from step 1?"],
    },
    chips: [
      { id:"Mulai setup", en:"Start setup", next:"inv_add_account" },
      { id:"Kembali", en:"Back", next:"inv_home" },
    ],
  },
  inv_copy_both: {
    msgs: {
      id: ["Copy Trader + Analyst — aktifkan kedua toggle di Copy Engine.\n\nSetup sama, di step akhir aktifkan:\n• Enable Copy Trader\n• Enable Copy Analyst\n\nMulai step 1?"],
      en: ["Copy Trader + Analyst — enable both toggles in Copy Engine.\n\nSame setup flow, at the last step enable:\n• Enable Copy Trader\n• Enable Copy Analyst\n\nStart from step 1?"],
    },
    chips: [
      { id:"Mulai setup", en:"Start setup", next:"inv_add_account" },
      { id:"Kembali", en:"Back", next:"inv_home" },
    ],
  },
  inv_add_account: {
    msgs: {
      id: ["Step 1 — Tambah akun broker.\n\nInvestor Dashboard → Settings → Broker Account → + Add Account.\n\nPilih tipe: Standard atau Cent (sesuai akun broker kamu)."],
      en: ["Step 1 — Add broker account.\n\nInvestor Dashboard → Settings → Broker Account → + Add Account.\n\nSelect type: Standard or Cent (matching your broker account type)."],
    },
    actions: [{ label:{ id:"Investor Settings", en:"Investor Settings" }, href:"/investor" }],
    chips: [
      { id:"Sudah add account ", en:"Account added ", next:"inv_dl_ea" },
      { id:"Kembali", en:"Back", next:"inv_home" },
    ],
  },
  inv_dl_ea: {
    msgs: {
      id: ["Step 2 — Download EA Investor v4.2 sesuai platform MT kamu."],
      en: ["Step 2 — Download EA Investor v4.2 for your MT platform."],
    },
    actions: [
      { label:{ id:"EA Investor MT5 v4.2 (.ex5)", en:"EA Investor MT5 v4.2 (.ex5)" }, href:"/api/ea/download/investor-mt5" },
      { label:{ id:"EA Investor MT4 (.ex4)", en:"EA Investor MT4 (.ex4)" }, href:"/api/ea/download/investor-mt4" },
    ],
    chips: [
      { id:"Sudah download ", en:"Downloaded ", next:"inv_install_ea" },
      { id:"Kembali", en:"Back", next:"inv_add_account" },
    ],
  },
  inv_install_ea: {
    msgs: {
      id: ["Step 3 — Install EA di MetaTrader.\n\n1. File → Open Data Folder\n2. Copy .ex5 ke MQL5/Experts/\n3. Restart MetaTrader\n4. Drag EA dari Navigator ke chart manapun"],
      en: ["Step 3 — Install EA in MetaTrader.\n\n1. File → Open Data Folder\n2. Copy .ex5 to MQL5/Experts/\n3. Restart MetaTrader\n4. Drag EA from Navigator to any chart"],
    },
    chips: [
      { id:"EA terpasang ", en:"EA installed ", next:"inv_gen_key" },
      { id:"Ada masalah install", en:"Installation issue", next:"inv_t_install" },
    ],
  },
  inv_gen_key: {
    msgs: {
      id: ["Step 4 — Generate EA Key per akun broker.\n\nInvestor Settings → EA Key per Account → Generate Key.\n\nCopy key yang muncul — akan di-paste ke EA di MT."],
      en: ["Step 4 — Generate EA Key per broker account.\n\nInvestor Settings → EA Key per Account → Generate Key.\n\nCopy the key — you'll paste it into the EA in MT."],
    },
    actions: [{ label:{ id:"Investor Settings", en:"Investor Settings" }, href:"/investor" }],
    chips: [
      { id:"Key sudah di-copy ", en:"Key copied ", next:"inv_autotrading" },
      { id:"Kembali", en:"Back", next:"inv_install_ea" },
    ],
  },
  inv_autotrading: {
    msgs: {
      id: ["Step 5 — Hubungkan EA ke CrunchAlpha.\n\n1. Double-click EA di chart → buka settings\n2. Paste EA Key ke kolom API Key\n3. Server URL: https://crunchalpha.com\n4. Klik OK\n5. Aktifkan AutoTrading di toolbar MT (ikon robot → hijau)"],
      en: ["Step 5 — Connect EA to CrunchAlpha.\n\n1. Double-click EA on chart → open settings\n2. Paste EA Key into API Key field\n3. Server URL: https://crunchalpha.com\n4. Click OK\n5. Enable AutoTrading in MT toolbar (robot icon → green)"],
    },
    chips: [
      { id:"EA Connected ", en:"EA Connected ", next:"inv_subscribe" },
      { id:"Tidak bisa connect", en:"Can't connect", next:"inv_t_connect" },
    ],
  },
  inv_subscribe: {
    msgs: {
      id: ["Step 6 — Subscribe & aktifkan Copy Engine.\n\nBuka Marketplace → pilih trader atau analyst yang ingin kamu ikuti → klik Subscribe.\n\nLalu Settings → Copy Engine → aktifkan toggle:\n• Enable Copy Trader (jika follow trader)\n• Enable Copy Analyst (jika follow analyst)"],
      en: ["Step 6 — Subscribe & activate Copy Engine.\n\nGo to Marketplace → choose a trader or analyst → click Subscribe.\n\nThen Settings → Copy Engine → enable the toggle:\n• Enable Copy Trader (for traders)\n• Enable Copy Analyst (for analysts)"],
    },
    actions: [{ label:{ id:"My Portfolio", en:"My Portfolio" }, href:"/investor" }],
    chips: [
      { id:"Semua aktif ", en:"All active ", next:"inv_done" },
      { id:"Kembali", en:"Back", next:"inv_autotrading" },
    ],
  },
  inv_done: {
    msgs: {
      id: ["Setup selesai! Copy engine aktif.\n\nPantau posisi di Live Positions dan performa di My Portfolio."],
      en: ["Setup complete! Copy engine is active.\n\nMonitor positions in Live Positions and performance in My Portfolio."],
    },
    actions: [
      { label:{ id:"Live Positions", en:"Live Positions" }, href:"/investor" },
      { label:{ id:"My Portfolio", en:"My Portfolio" }, href:"/investor" },
    ],
    chips: [{ id:"Ada pertanyaan lain?", en:"Any other questions?", next:"inv_home" }],
  },
  inv_billing: {
    msgs: {
      id: ["Subscription:\n\nBasic $9.99/mo\n• 1 follower account, max 3 copy traders, max 3 signal sets\n• Max 20 alokasi per akun\n\nPremium $29.99/mo\n• Unlimited follower accounts, traders & signal sets\n• Auto-rebalance by AlphaScore\n• DD Guard & advanced analytics\n\nPerformance Fee: 25% of profit (HWM)"],
      en: ["Subscription:\n\nBasic $9.99/mo\n• 1 follower account, max 3 copy traders, max 3 signal sets\n• Max 20 allocations per account\n\nPremium $29.99/mo\n• Unlimited follower accounts, traders & signal sets\n• Auto-rebalance by AlphaScore\n• DD Guard & advanced analytics\n\nPerformance Fee: 25% of profit (HWM)"],
    },
    actions: [{ label:{ id:"Lihat Billing", en:"View Billing" }, href:"/investor/billing" }],
    chips: [{ id:"Kembali", en:"Back", next:"inv_home" }],
  },
  inv_trouble: {
    msgs: { id:["Troubleshoot Investor:"], en:["Investor Troubleshoot:"] },
    chips: [
      { id:"EA tidak connect", en:"EA won't connect", next:"inv_t_connect" },
      { id:"Trade tidak ter-copy", en:"Trades not copying", next:"inv_t_copy" },
      { id:"Posisi berbeda dengan trader", en:"Position differs from trader", next:"inv_t_pos" },
      { id:"Kembali", en:"Back", next:"inv_home" },
    ],
  },
  inv_t_install: {
    msgs: {
      id: ["Checklist install:\n• File .ex5 di MQL5/Experts/ (bukan subfolder)\n• MT di-restart setelah copy file\n• EA muncul di Navigator panel kiri\n• Drag ke chart SETELAH restart"],
      en: ["Install checklist:\n• .ex5 file in MQL5/Experts/ (not a subfolder)\n• MT restarted after copying file\n• EA appears in Navigator panel\n• Drag to chart AFTER restart"],
    },
    chips: [
      { id:"Masih tidak muncul", en:"Still not showing", next:"inv_t_connect" },
      { id:"Sudah beres ", en:"Fixed ", next:"inv_gen_key" },
    ],
  },
  inv_t_connect: {
    msgs: {
      id: ["Checklist koneksi EA:\n1. EA Key sudah di-generate di Settings → EA Key per Account?\n2. Copy-paste key (jangan ketik manual)\n3. Server URL: https://crunchalpha.com\n4. Allow Live Trading & AutoTrading: aktif\n5. Cek tab Journal di MT untuk error"],
      en: ["EA connection checklist:\n1. EA Key generated in Settings → EA Key per Account?\n2. Copy-paste the key (don't type manually)\n3. Server URL: https://crunchalpha.com\n4. Allow Live Trading & AutoTrading: active\n5. Check MT Journal tab for error messages"],
    },
    chips: [
      { id:"Masih error", en:"Still error", next:"inv_t_contact" },
      { id:"Sudah connect ", en:"Connected ", next:"inv_subscribe" },
    ],
  },
  inv_t_copy: {
    msgs: {
      id: ["Trade tidak ter-copy:\n• Copy Engine toggle aktif? (Enable Copy Trader/Analyst)\n• Balance cukup untuk lot minimum?\n• Cek Copy History → ada signal REJECTED?\n• Pair tersedia di broker kamu?"],
      en: ["Trades not copying:\n• Copy Engine toggle active? (Enable Copy Trader/Analyst)\n• Sufficient balance for minimum lot?\n• Check Copy History → any REJECTED signals?\n• Pair available at your broker?"],
    },
    actions: [{ label:{ id:"Copy History", en:"Copy History" }, href:"/investor" }],
    chips: [
      { id:"Ada signal REJECTED", en:"There are REJECTED signals", next:"inv_t_rejected" },
      { id:"Kembali", en:"Back", next:"inv_trouble" },
    ],
  },
  inv_t_rejected: {
    msgs: {
      id: ["Signal REJECTED biasanya karena:\n• Balance tidak cukup\n• Pair tidak ada di broker\n• Leverage terlalu rendah\n• Max Open Trades sudah tercapai\n• Akun margin call\n\nDetail di Copy History → Signal Copy History."],
      en: ["Signal REJECTED usually because:\n• Insufficient balance\n• Pair not available at broker\n• Leverage too low\n• Max Open Trades reached\n• Account in margin call\n\nDetails in Copy History → Signal Copy History."],
    },
    chips: [{ id:"Kembali", en:"Back", next:"inv_trouble" }],
  },
  inv_t_pos: {
    msgs: {
      id: ["Posisi berbeda:\n• Lot size menyesuaikan AUM-based calculation — normal\n• Ghost position → tunggu 1-2 menit rekonsiliasi otomatis\n• Jika > 5 menit, hubungi support"],
      en: ["Position differs:\n• Lot size adjusts by AUM-based calculation — this is normal\n• Ghost position → wait 1-2 min for auto-reconciliation\n• If > 5 minutes, contact support"],
    },
    chips: [{ id:"Kembali", en:"Back", next:"inv_trouble" }],
  },
  inv_t_contact: {
    msgs: {
      id: ["Hubungi support:\n• Email: support@crunchalpha.com\n• Sertakan: nomor akun, error dari Journal MT, screenshot"],
      en: ["Contact support:\n• Email: support@crunchalpha.com\n• Include: account number, MT Journal error, screenshot"],
    },
    chips: [{ id:"Kembali ke Home", en:"Back to Home", next:"inv_home" }],
  },

  /* ── TRADER ──────────────────────────────── */
  tr_home: {
    msgs: {
      id: ["Halo Trader!\n\nSebagai trader, investor akan copy trade kamu otomatis via EA Publisher.\n\nMau mulai dari mana?"],
      en: ["Hello Trader!\n\nAs a trader, investors will automatically copy your trades via EA Publisher.\n\nWhat would you like to do?"],
    },
    chips: [
      { id:"Setup Akun Baru", en:"Setup New Account", next:"tr_add1" },
      { id:"Download EA Publisher", en:"Download EA Publisher", next:"tr_ea" },
      { id:"AlphaRank & Score", en:"AlphaRank & Score", next:"tr_alpha" },
      { id:"Troubleshoot", en:"Troubleshoot", next:"tr_trouble" },
    ],
  },
  tr_add1: {
    msgs: {
      id: ["Step 1 — Tambah akun trading.\n\nTrader Dashboard → tab Accounts → Add Account.\n\nMasukkan: nickname, broker, platform (MT4/MT5), nomor akun."],
      en: ["Step 1 — Add trading account.\n\nTrader Dashboard → Accounts tab → Add Account.\n\nEnter: nickname, broker, platform (MT4/MT5), account number."],
    },
    actions: [{ label:{ id:"Trader Dashboard", en:"Trader Dashboard" }, href:"/trader" }],
    chips: [
      { id:"Sudah add account ", en:"Account added ", next:"tr_dl_ea" },
      { id:"Kembali", en:"Back", next:"tr_home" },
    ],
  },
  tr_dl_ea: {
    msgs: { id:["Step 2 — Download EA Publisher v4.1."], en:["Step 2 — Download EA Publisher v4.1."] },
    actions: [
      { label:{ id:"EA Publisher MT5 (.ex5)", en:"EA Publisher MT5 (.ex5)" }, href:"/api/ea/download/mt5" },
      { label:{ id:"EA Publisher MT4 (.ex4)", en:"EA Publisher MT4 (.ex4)" }, href:"/api/ea/download/mt4" },
    ],
    chips: [
      { id:"Sudah download ", en:"Downloaded ", next:"tr_install_ea" },
      { id:"Kembali", en:"Back", next:"tr_add1" },
    ],
  },
  tr_install_ea: {
    msgs: {
      id: ["Step 3 — Install di MetaTrader.\n\n1. File → Open Data Folder\n2. Copy ke MQL5/Experts/ (MT5) atau MQL4/Experts/ (MT4)\n3. Restart MetaTrader\n4. Drag EA ke chart manapun"],
      en: ["Step 3 — Install in MetaTrader.\n\n1. File → Open Data Folder\n2. Copy to MQL5/Experts/ (MT5) or MQL4/Experts/ (MT4)\n3. Restart MetaTrader\n4. Drag EA to any chart"],
    },
    chips: [
      { id:"EA terpasang ", en:"EA installed ", next:"tr_gen_key" },
      { id:"Ada masalah", en:"Issue with install", next:"tr_t_install" },
    ],
  },
  tr_gen_key: {
    msgs: {
      id: ["Step 4 — Generate EA Key.\n\nTrader Dashboard → tab Accounts → EA Setup & Download → Generate EA Key.\n\nCopy key yang muncul."],
      en: ["Step 4 — Generate EA Key.\n\nTrader Dashboard → Accounts tab → EA Setup & Download → Generate EA Key.\n\nCopy the generated key."],
    },
    actions: [{ label:{ id:"Trader Dashboard", en:"Trader Dashboard" }, href:"/trader" }],
    chips: [
      { id:"Key sudah di-copy ", en:"Key copied ", next:"tr_autotrading" },
      { id:"Kembali", en:"Back", next:"tr_install_ea" },
    ],
  },
  tr_autotrading: {
    msgs: {
      id: ["Step 5 — Hubungkan EA.\n\n1. Double-click EA di chart → settings\n2. Paste EA Key ke API Key\n3. Server URL: https://crunchalpha.com\n4. Klik OK\n5. Aktifkan AutoTrading di toolbar MT\n\nStatus di dashboard akan berubah jadi Connected."],
      en: ["Step 5 — Connect EA.\n\n1. Double-click EA on chart → settings\n2. Paste EA Key into API Key\n3. Server URL: https://crunchalpha.com\n4. Click OK\n5. Enable AutoTrading in MT toolbar\n\nDashboard status will change to Connected."],
    },
    chips: [
      { id:"EA Connected ", en:"EA Connected ", next:"tr_done" },
      { id:"Tidak bisa connect", en:"Can't connect", next:"tr_t_connect" },
    ],
  },
  tr_done: {
    msgs: {
      id: ["Setup selesai!\n\nEA Publisher aktif — setiap trade yang kamu buka di MT akan ter-push ke CrunchAlpha.\n\nAlphaRank terbentuk setelah beberapa trade closed. Investor bisa mulai follow kamu."],
      en: ["Setup complete!\n\nEA Publisher is active — every trade you open in MT will push to CrunchAlpha.\n\nAlphaRank builds after a few closed trades. Investors can start following you."],
    },
    actions: [{ label:{ id:"Trader Dashboard", en:"Trader Dashboard" }, href:"/trader" }],
    chips: [
      { id:"Pelajari AlphaRank", en:"Learn AlphaRank", next:"tr_alpha" },
      { id:"Pertanyaan lain?", en:"Other questions?", next:"tr_home" },
    ],
  },
  tr_ea: {
    msgs: { id:["Download EA Publisher v4.1:"], en:["Download EA Publisher v4.1:"] },
    actions: [
      { label:{ id:"EA Publisher MT5 (.ex5)", en:"EA Publisher MT5 (.ex5)" }, href:"/api/ea/download/mt5" },
      { label:{ id:"EA Publisher MT4 (.ex4)", en:"EA Publisher MT4 (.ex4)" }, href:"/api/ea/download/mt4" },
    ],
    chips: [
      { id:"Cara install", en:"How to install", next:"tr_install_ea" },
      { id:"Kembali", en:"Back", next:"tr_home" },
    ],
  },
  tr_alpha: {
    msgs: {
      id: ["AlphaRank — sistem penilaian trader CrunchAlpha.\n\nAlphaScore dari 7 Pilar:\nP1 Profitability — total keuntungan bersih\nP2 Consistency — konsistensi return dari waktu ke waktu\nP3 Risk Management — disiplin SL/TP & risk flags\nP4 Recovery Resilience — kecepatan recovery dari drawdown\nP5 Trading Edge — ekspektansi & edge score\nP6 Discipline — menghindari revenge trading\nP7 Track Record — jumlah trade & panjang histori"],
      en: ["AlphaRank — CrunchAlpha's trader rating system.\n\nAlphaScore from 7 Pillars:\nP1 Profitability — total net profit\nP2 Consistency — return consistency over time\nP3 Risk Management — SL/TP discipline & risk flags\nP4 Recovery Resilience — recovery speed from drawdown\nP5 Trading Edge — expectancy & edge score\nP6 Discipline — avoiding revenge trading\nP7 Track Record — trade count & history length"],
    },
    chips: [
      { id:"Grading System", en:"Grading System", next:"tr_alpha_grade" },
      { id:"Flags (Peringatan)", en:"Flags (Warnings)", next:"tr_alpha_flags" },
      { id:"Risk Profile", en:"Risk Profile", next:"tr_alpha_risk" },
      { id:"Kembali", en:"Back", next:"tr_home" },
    ],
  },
  tr_alpha_grade: {
    msgs: {
      id: ["Grade AlphaScore:\n\nA+ ≥ 90   A ≥ 85   A- ≥ 80\nB+ ≥ 75   B ≥ 70   B- ≥ 65\nC+ ≥ 60   C ≥ 55   C- ≥ 50\nD ≥ 40    F < 40"],
      en: ["AlphaScore Grades:\n\nA+ ≥ 90   A ≥ 85   A- ≥ 80\nB+ ≥ 75   B ≥ 70   B- ≥ 65\nC+ ≥ 60   C ≥ 55   C- ≥ 50\nD ≥ 40    F < 40"],
    },
    chips: [
      { id:"Lihat Flags", en:"See Flags", next:"tr_alpha_flags" },
      { id:"Kembali", en:"Back", next:"tr_alpha" },
    ],
  },
  tr_alpha_flags: {
    msgs: {
      id: ["AlphaRank Flags (MAJOR):\n\n   No Stop Loss — tidak pakai SL\n   High Drawdown — DD > 20%\n   Extreme Position Sizing — avg P&L/trade > 15%\n\nFlags MAJOR menurunkan AlphaScore signifikan."],
      en: ["AlphaRank Flags (MAJOR):\n\n   No Stop Loss — no SL used\n   High Drawdown — DD > 20%\n   Extreme Position Sizing — avg P&L/trade > 15%\n\nMAJOR flags significantly reduce AlphaScore."],
    },
    chips: [
      { id:"Risk Profile", en:"Risk Profile", next:"tr_alpha_risk" },
      { id:"Kembali", en:"Back", next:"tr_alpha" },
    ],
  },
  tr_alpha_risk: {
    msgs: {
      id: ["Risk Profile:\n• Conservative — DD rendah, lot kecil\n• Balanced — risk sedang\n• Aggressive — lot besar, DD tinggi\n• High Risk — DD > 30%\n• Extreme — penalty AlphaScore\n\nInformasional kecuali Extreme."],
      en: ["Risk Profile:\n• Conservative — low DD, small lot\n• Balanced — moderate risk\n• Aggressive — large lot, high DD\n• High Risk — DD > 30%\n• Extreme — AlphaScore penalty\n\nInformational only except Extreme."],
    },
    chips: [{ id:"Kembali ke AlphaRank", en:"Back to AlphaRank", next:"tr_alpha" }],
  },
  tr_trouble: {
    msgs: { id:["Troubleshoot Trader:"], en:["Trader Troubleshoot:"] },
    chips: [
      { id:"EA tidak connect", en:"EA won't connect", next:"tr_t_connect" },
      { id:"Data tidak update", en:"Data not updating", next:"tr_t_data" },
      { id:"AlphaScore tidak akurat", en:"AlphaScore inaccurate", next:"tr_t_alpha" },
      { id:"Kembali", en:"Back", next:"tr_home" },
    ],
  },
  tr_t_install: {
    msgs: {
      id: ["Checklist install:\n• File di MQL5/Experts/ (bukan subfolder)\n• MT di-restart setelah copy\n• EA muncul di Navigator\n• Drag ke chart setelah restart"],
      en: ["Install checklist:\n• File in MQL5/Experts/ (not a subfolder)\n• MT restarted after copy\n• EA visible in Navigator\n• Drag to chart after restart"],
    },
    chips: [
      { id:"Masih error", en:"Still error", next:"tr_t_connect" },
      { id:"Sudah beres ", en:"Fixed ", next:"tr_gen_key" },
    ],
  },
  tr_t_connect: {
    msgs: {
      id: ["Checklist koneksi:\n1. EA Key dari dashboard → copy-paste (jangan ketik manual)\n2. Server URL: https://crunchalpha.com\n3. Allow Live Trading: aktif\n4. AutoTrading: aktif (ikon robot hijau)\n5. Cek Journal MT untuk error"],
      en: ["Connection checklist:\n1. EA Key from dashboard → copy-paste (don't type manually)\n2. Server URL: https://crunchalpha.com\n3. Allow Live Trading: active\n4. AutoTrading: active (green robot icon)\n5. Check MT Journal for errors"],
    },
    chips: [
      { id:"Masih tidak connect", en:"Still not connecting", next:"tr_t_contact" },
      { id:"Sudah connect ", en:"Connected ", next:"tr_done" },
    ],
  },
  tr_t_data: {
    msgs: {
      id: ["Data tidak update:\n• EA Publisher aktif & running di chart MT?\n• Cek Journal MT — ada Failed to push?\n• Coba close & re-attach EA ke chart"],
      en: ["Data not updating:\n• EA Publisher active & running on MT chart?\n• Check MT Journal — any Failed to push?\n• Try closing & re-attaching EA to chart"],
    },
    chips: [{ id:"Kembali", en:"Back", next:"tr_trouble" }],
  },
  tr_t_alpha: {
    msgs: {
      id: ["AlphaScore butuh:\n• Beberapa trade CLOSED\n• Data equity beberapa hari\n• EA Publisher aktif push data\n\nUpdate otomatis tiap trade baru closed."],
      en: ["AlphaScore requires:\n• Several CLOSED trades\n• A few days of equity data\n• EA Publisher actively pushing data\n\nAuto-updates with each new closed trade."],
    },
    chips: [{ id:"Kembali", en:"Back", next:"tr_trouble" }],
  },
  tr_t_contact: {
    msgs: {
      id: ["Hubungi support:\n• Email: support@crunchalpha.com\n• Sertakan: nomor akun, error Journal MT, screenshot"],
      en: ["Contact support:\n• Email: support@crunchalpha.com\n• Include: account number, MT Journal error, screenshot"],
    },
    chips: [{ id:"Kembali ke Home", en:"Back to Home", next:"tr_home" }],
  },

  /* ── ANALYST ─────────────────────────────── */
  an_home: {
    msgs: {
      id: ["Halo Analyst!\n\nSebagai analyst, kamu mengirim signal yang di-execute otomatis ke akun investor subscriber.\n\nTidak perlu EA — semua dari dashboard.\n\nMau mulai dari mana?"],
      en: ["Hello Analyst!\n\nAs an analyst, you send signals that auto-execute into subscriber investor accounts.\n\nNo EA needed — everything from the dashboard.\n\nWhat would you like to do?"],
    },
    chips: [
      { id:"Setup Signal Set Baru", en:"Setup New Signal Set", next:"an_setup1" },
      { id:"Cara Send Signal", en:"How to Send Signal", next:"an_send" },
      { id:"AlphaScore & Statistik", en:"AlphaScore & Statistics", next:"an_alpha" },
      { id:"Troubleshoot", en:"Troubleshoot", next:"an_trouble" },
    ],
  },
  an_setup1: {
    msgs: {
      id: ["Step 1 — Buat Signal Set.\n\nAnalyst Dashboard → klik + Signal Set.\n\nBeri nama dan deskripsi. Signal Set adalah 'channel' yang investor subscribe untuk menerima signal kamu."],
      en: ["Step 1 — Create Signal Set.\n\nAnalyst Dashboard → click + Signal Set.\n\nAdd a name and description. A Signal Set is the 'channel' investors subscribe to for your signals."],
    },
    actions: [{ label:{ id:"Analyst Dashboard", en:"Analyst Dashboard" }, href:"/analyst" }],
    chips: [
      { id:"Signal Set dibuat ", en:"Signal Set created ", next:"an_setup2" },
      { id:"Kembali", en:"Back", next:"an_home" },
    ],
  },
  an_setup2: {
    msgs: {
      id: ["Step 2 — Kirim signal pertama.\n\nDashboard → tab Send Signal:\n1. Pilih Signal Set\n2. Pilih pair (misal XAUUSD)\n3. Pilih BUY atau SELL\n4. Klik chart untuk auto-fill entry\n5. Isi Stop Loss & Take Profit\n6. Klik Send Signal"],
      en: ["Step 2 — Send your first signal.\n\nDashboard → Send Signal tab:\n1. Select Signal Set\n2. Select pair (e.g. XAUUSD)\n3. Choose BUY or SELL\n4. Click chart to auto-fill entry\n5. Enter Stop Loss & Take Profit\n6. Click Send Signal"],
    },
    actions: [{ label:{ id:"Send Signal", en:"Send Signal" }, href:"/analyst" }],
    chips: [
      { id:"Signal terkirim ", en:"Signal sent ", next:"an_done" },
      { id:"Ada masalah", en:"Having issues", next:"an_trouble" },
    ],
  },
  an_done: {
    msgs: {
      id: ["Setup selesai!\n\nSignal aktif — investor yang subscribe Signal Set kamu akan ter-execute otomatis via EA mereka.\n\nPantau di tab Active, Running, dan History."],
      en: ["Setup complete!\n\nSignal is live — investors subscribed to your Signal Set will auto-execute via their EA.\n\nMonitor in Active, Running, and History tabs."],
    },
    actions: [{ label:{ id:"Analyst Dashboard", en:"Analyst Dashboard" }, href:"/analyst" }],
    chips: [
      { id:"Cara lihat statistik", en:"View statistics", next:"an_alpha" },
      { id:"Ada pertanyaan lain?", en:"Other questions?", next:"an_home" },
    ],
  },
  an_send: {
    msgs: {
      id: ["Cara Send Signal:\n\n1. Dashboard → tab Send Signal\n2. Pilih Signal Set aktif\n3. Pilih pair trading\n4. Pilih BUY atau SELL\n5. Klik chart untuk auto-fill entry (atau ketik manual)\n6. Isi SL & TP\n7. Klik Send Signal"],
      en: ["How to Send Signal:\n\n1. Dashboard → Send Signal tab\n2. Select active Signal Set\n3. Select trading pair\n4. Choose BUY or SELL\n5. Click chart to auto-fill entry (or type manually)\n6. Enter SL & TP\n7. Click Send Signal"],
    },
    actions: [{ label:{ id:"Analyst Dashboard", en:"Analyst Dashboard" }, href:"/analyst" }],
    chips: [{ id:"Kembali", en:"Back", next:"an_home" }],
  },
  an_alpha: {
    msgs: {
      id: ["AlphaScore Analyst dihitung dari performa signal:\n\nAlphaScore dihitung dari 7 Pilar:\nP1 Profitability — total keuntungan bersih\nP2 Consistency — konsistensi return dari waktu ke waktu\nP3 Risk Management — disiplin SL/TP & risk flags\nP4 Recovery Resilience — kecepatan recovery dari drawdown\nP5 Trading Edge — ekspektansi & edge score\nP6 Discipline — menghindari revenge trading\nP7 Track Record — jumlah trade & panjang histori\n\nGrade: A+≥90, A≥85, A-≥80, B+≥75, B≥70, B-≥65, C+≥60, C≥55, C-≥50, D≥40, F<40\n\nCek di tab Statistics & Summary."],
      en: ["Analyst AlphaScore is calculated from signal performance:\n\nAlphaScore dihitung dari 7 Pilar:\nP1 Profitability — total keuntungan bersih\nP2 Consistency — konsistensi return dari waktu ke waktu\nP3 Risk Management — disiplin SL/TP & risk flags\nP4 Recovery Resilience — kecepatan recovery dari drawdown\nP5 Trading Edge — ekspektansi & edge score\nP6 Discipline — menghindari revenge trading\nP7 Track Record — jumlah trade & panjang histori\n\nGrade: A+≥90, A≥85, A-≥80, B+≥75, B≥70, B-≥65, C+≥60, C≥55, C-≥50, D≥40, F<40\n\nCheck in Statistics & Summary tabs."],
    },
    actions: [{ label:{ id:"Analyst Dashboard", en:"Analyst Dashboard" }, href:"/analyst" }],
    chips: [{ id:"Kembali", en:"Back", next:"an_home" }],
  },
  an_trouble: {
    msgs: { id:["Troubleshoot Analyst:"], en:["Analyst Troubleshoot:"] },
    chips: [
      { id:"Signal tidak ter-execute", en:"Signal not executing", next:"an_t_exec" },
      { id:"Signal Set tidak muncul", en:"Signal Set missing", next:"an_t_set" },
      { id:"Kembali", en:"Back", next:"an_home" },
    ],
  },
  an_t_exec: {
    msgs: {
      id: ["Signal tidak ter-execute:\n• Investor sudah subscribe Signal Set kamu?\n• EA Investor investor aktif & connected?\n• Enable Copy Analyst aktif di Copy Engine investor?\n• Cek tab History — signal tercatat?"],
      en: ["Signal not executing:\n• Has investor subscribed to your Signal Set?\n• Is investor's EA Investor active & connected?\n• Is Enable Copy Analyst active in investor's Copy Engine?\n• Check History tab — is signal recorded?"],
    },
    chips: [{ id:"Kembali", en:"Back", next:"an_trouble" }],
  },
  an_t_set: {
    msgs: {
      id: ["Signal Set tidak muncul:\n• Coba refresh dashboard\n• Pastikan status Signal Set: Active\n• Max signal set bergantung plan investor subscriber\n\nMasalah berlanjut: support@crunchalpha.com"],
      en: ["Signal Set missing:\n• Try refreshing dashboard\n• Ensure Signal Set status: Active\n• Max signal sets depend on subscriber's plan\n\nPersisting issue: support@crunchalpha.com"],
    },
    chips: [{ id:"Kembali", en:"Back", next:"an_home" }],
  },

  /* ── VISITOR ─────────────────────────────── */
  vis_home: {
    msgs: {
      id: ["Selamat datang di CrunchAlpha!\n\nCrunchAlpha adalah platform copy trading yang menghubungkan trader & analyst profesional dengan investor."],
      en: ["Welcome to CrunchAlpha!\n\nCrunchAlpha is a copy trading platform connecting professional traders & analysts with investors."],
    },
    chips: [
      { id:"Cara Kerja Platform", en:"How It Works", next:"vis_howitworks" },
      { id:"Apa itu Copy Trade?", en:"What is Copy Trading?", next:"vis_copytrade" },
      { id:"Untuk Investor", en:"For Investors", next:"vis_investor" },
      { id:"Untuk Trader", en:"For Traders", next:"vis_trader" },
      { id:"Untuk Analyst", en:"For Analysts", next:"vis_analyst" },
      { id:"Cara Daftar", en:"How to Register", next:"vis_register" },
    ],
  },
  vis_howitworks: {
    msgs: {
      id: ["CrunchAlpha bekerja dalam 3 langkah:\n\n1. Pilih Provider\n   Browse trader/analyst di Marketplace berdasarkan AlphaRank™\n\n2. Set Allocation\n   Tentukan % modal yang ingin dialokasikan — sistem otomatis hitung lot\n\n3. Copy Otomatis dengan Risk Control\n   EA Investor copy setiap trade real-time dengan lot yang dinormalisasi sesuai modal kamu\n\nPlatform non-custodial — dana tetap di akun broker kamu sendiri."],
      en: ["CrunchAlpha works in 3 steps:\n\n1. Choose Provider\n   Browse traders/analysts on Marketplace by AlphaRank™\n\n2. Set Allocation\n   Set the % of capital to allocate — system auto-calculates lot\n\n3. Auto Copy with Risk Control\n   EA Investor copies every trade real-time with lot normalized to your capital\n\nNon-custodial — funds stay in your own broker account."],
    },
    chips: [
      { id:"Apa itu Risk Normalization?", en:"What is Risk Normalization?", next:"vis_risknorm" },
      { id:"Cara membaca AlphaRank", en:"How to read AlphaRank", next:"vis_alpharank" },
      { id:"Cara Daftar", en:"How to Register", next:"vis_register" },
      { id:"Kembali", en:"Back", next:"vis_home" },
    ],
  },
  vis_risknorm: {
    msgs: {
      id: ["Risk Normalization — lot size otomatis disesuaikan dengan modal kamu.\n\nContoh sederhana:\n• Provider: modal $10.000, lot 1.0\n• Kamu: modal $1.000 (10% dari provider)\n• Sistem copy dengan lot 0.1 (10% dari 1.0)\n\nKamu tidak perlu modal besar untuk copy trader — sistem menyesuaikan secara otomatis.\n\nApakah ada yang masih bingung?"],
      en: ["Risk Normalization — lot size is automatically adjusted to your capital.\n\nSimple example:\n• Provider: $10,000 capital, lot 1.0\n• You: $1,000 capital (10% of provider)\n• System copies with lot 0.1 (10% of 1.0)\n\nYou don't need large capital to copy — the system adjusts automatically.\n\nAny questions?"],
    },
    chips: [
      { id:"Cara set allocation", en:"How to set allocation", next:"vis_allocation" },
      { id:"Kembali", en:"Back", next:"vis_howitworks" },
    ],
  },
  vis_allocation: {
    msgs: {
      id: ["Allocation adalah % modal yang kamu dedikasikan per provider.\n\nPanduan umum (bukan saran investasi):\n• Conservative: max 20-30% per provider\n• Balanced: max 30-50% per provider\n• Jangan taruh semua modal ke 1 provider\n\nContoh: modal $1.000, alokasi 30% → sistem gunakan $300 sebagai basis hitung lot.\n\nApakah ada yang masih bingung?"],
      en: ["Allocation is the % of capital dedicated per provider.\n\nGeneral guidance (not investment advice):\n• Conservative: max 20-30% per provider\n• Balanced: max 30-50% per provider\n• Never put all capital into 1 provider\n\nExample: $1,000 capital, 30% allocation → system uses $300 as lot calculation basis.\n\nAny questions?"],
    },
    chips: [
      { id:"Cara Daftar", en:"How to Register", next:"vis_register" },
      { id:"Kembali", en:"Back", next:"vis_howitworks" },
    ],
  },
  vis_alpharank: {
    msgs: {
      id: ["Cara membaca AlphaRank™:\n\n• Grade A (≥85): Track record kuat, risk terkelola   \n• Grade B (70-84): Performa baik, risk sedang\n• Grade C (50-69): Cukup, perlu hati-hati\n• Grade D/F (<50): Hindari dulu\n\nPerhatikan juga:\n• Max DD: semakin kecil semakin baik\n• Risk Flags MAJOR: pertimbangkan ulang\n• Risk Level: sesuaikan profil risiko kamu\n\nCrunchAlpha tidak merekomendasikan provider tertentu — keputusan ada di tangan kamu."],
      en: ["How to read AlphaRank™:\n\n• Grade A (≥85): Strong track record, managed risk   \n• Grade B (70-84): Good performance, moderate risk\n• Grade C (50-69): Decent, proceed with caution\n• Grade D/F (<50): Avoid for now\n\nAlso check:\n• Max DD: lower is better\n• MAJOR Risk Flags: reconsider\n• Risk Level: match your risk profile\n\nCrunchAlpha does not recommend specific providers — the decision is yours."],
    },
    chips: [
      { id:"Cara Daftar", en:"How to Register", next:"vis_register" },
      { id:"Kembali", en:"Back", next:"vis_howitworks" },
    ],
  },
  vis_copytrade: {
    msgs: {
      id: ["Copy Trade memungkinkan kamu menduplikasi trade dari trader profesional secara otomatis — tanpa perlu analisis pasar sendiri.\n\nKamu juga bisa follow Analyst dan menerima signal trading yang langsung ter-execute di akun MT kamu."],
      en: ["Copy Trading lets you automatically duplicate trades from professional traders — no market analysis needed.\n\nYou can also follow Analysts and receive trading signals that execute directly in your MT account."],
    },
    chips: [
      { id:"Untuk Investor", en:"For Investors", next:"vis_investor" },
      { id:"Cara Daftar", en:"How to Register", next:"vis_register" },
    ],
  },
  vis_investor: {
    msgs: {
      id: ["Sebagai Investor:\n• Browse trader/analyst berdasarkan AlphaRank\n• Subscribe ke trader atau signal set analyst\n• Copy trade/signal otomatis via EA Investor\n• Monitor performa di dashboard\n• Bayar Performance Fee hanya dari profit (HWM)\n\nPlan mulai dari $9.99/mo"],
      en: ["As an Investor:\n• Browse traders/analysts by AlphaRank\n• Subscribe to traders or analyst signal sets\n• Auto copy trade/signals via EA Investor\n• Monitor performance on dashboard\n• Performance Fee only on profit (HWM)\n\nPlans starting from $9.99/mo"],
    },
    chips: [
      { id:"Cara Daftar", en:"How to Register", next:"vis_register" },
      { id:"Kembali", en:"Back", next:"vis_home" },
    ],
  },
  vis_trader: {
    msgs: {
      id: ["Sebagai Trader:\n• Daftarkan akun trading kamu\n• Install EA Publisher di MetaTrader\n• Trade seperti biasa — investor akan copy\n• Bangun reputasi via AlphaRank\n• Dapatkan Performance Fee dari profit investor"],
      en: ["As a Trader:\n• Register your trading account\n• Install EA Publisher in MetaTrader\n• Trade as usual — investors will copy\n• Build reputation via AlphaRank\n• Earn Performance Fee from investor profits"],
    },
    chips: [
      { id:"Cara Daftar", en:"How to Register", next:"vis_register" },
      { id:"Kembali", en:"Back", next:"vis_home" },
    ],
  },
  vis_analyst: {
    msgs: {
      id: ["Sebagai Analyst:\n• Buat Signal Set dan kirim signal trading\n• Investor subscribe dan signal ter-execute otomatis\n• Tidak perlu EA — semua dari dashboard\n• Bangun track record via AlphaScore\n• Dapatkan Performance Fee dari profit investor"],
      en: ["As an Analyst:\n• Create Signal Sets and send trading signals\n• Investors subscribe and signals auto-execute\n• No EA needed — everything from dashboard\n• Build track record via AlphaScore\n• Earn Performance Fee from investor profits"],
    },
    chips: [
      { id:"Cara Daftar", en:"How to Register", next:"vis_register" },
      { id:"Kembali", en:"Back", next:"vis_home" },
    ],
  },
  vis_register: {
    msgs: {
      id: ["Cara daftar:\n1. Buka https://crunchalpha.com\n2. Klik Register\n3. Isi email & password\n4. Pilih role: Investor, Trader, atau Analyst\n5. Verifikasi email\n6. Mulai!"],
      en: ["How to register:\n1. Go to https://crunchalpha.com\n2. Click Register\n3. Enter email & password\n4. Choose role: Investor, Trader, or Analyst\n5. Verify email\n6. Get started!"],
    },
    actions: [{ label:{ id:"Daftar Sekarang", en:"Register Now" }, href:"/register" }],
    chips: [{ id:"Kembali", en:"Back", next:"vis_home" }],
  },
};

function searchKB(raw) {
  if (!raw || raw.trim().length < 2) return [];
  const q = raw.toLowerCase().trim();
  const words = q.split(/\s+/).filter((w) => w.length > 2);
  return KB.map((item) => {
    let score = 0;
    item.kw.forEach((kw) => {
      if (q.includes(kw)) score += 4;
      else if (words.some((w) => kw.includes(w))) score += 1;
    });
    return { ...item, score };
  }).filter((i) => i.score > 0).sort((a, b) => b.score - a.score).slice(0, 3);
}

const STYLE = `
.ca-widget{position:fixed;bottom:24px;right:24px;z-index:9999;font-family:'Inter',system-ui,sans-serif}
.ca-fab{width:56px;height:56px;border-radius:50%;background:linear-gradient(145deg,var(--accent,#4e9af1),#2563EB);border:2px solid rgba(255,255,255,.18);cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 20px rgba(37,99,235,.45);transition:transform .18s,box-shadow .18s;color:#fff;margin-left:auto}
.ca-fab:hover{transform:scale(1.08);box-shadow:0 6px 28px rgba(78,154,241,.6)}
.ca-panel{position:absolute;bottom:68px;right:0;width:360px;max-height:560px;display:flex;flex-direction:column;background:#111827;border:1px solid rgba(255,255,255,.08);border-radius:16px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.55);animation:ca-up .22s ease}
@media(max-width:420px){.ca-panel{width:calc(100vw - 32px);right:-8px}}
@keyframes ca-up{from{opacity:0;transform:translateY(12px) scale(.97)}to{opacity:1;transform:none}}
.ca-hdr{display:flex;align-items:center;gap:10px;padding:12px 14px;background:#0f1623;border-bottom:1px solid rgba(255,255,255,.07);flex-shrink:0}
.ca-av{width:34px;height:34px;border-radius:50%;background:linear-gradient(135deg,var(--accent,#4e9af1),#7b5ea7);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0}
.ca-hn{font-size:13px;font-weight:600;color:#f0f4ff;line-height:1.2}
.ca-hs{font-size:10.5px;color:rgba(255,255,255,.4);margin-top:1px}
.ca-hx{background:none;border:none;cursor:pointer;color:rgba(255,255,255,.4);font-size:17px;display:flex;align-items:center;padding:4px;border-radius:6px;transition:color .15s,background .15s;flex-shrink:0;line-height:1}
.ca-hx:hover{color:#fff;background:rgba(255,255,255,.08)}
.ca-lang{display:flex;gap:2px;background:rgba(255,255,255,.06);border-radius:8px;padding:2px;flex-shrink:0}
.ca-lang button{background:none;border:none;cursor:pointer;font-size:10.5px;font-weight:600;padding:3px 7px;border-radius:6px;transition:background .15s,color .15s;color:rgba(255,255,255,.4);line-height:1}
.ca-lang button.active{background:var(--accent,#4e9af1);color:#fff}
.ca-log{flex:1;overflow-y:auto;padding:12px 12px 4px;display:flex;flex-direction:column;gap:4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.1) transparent}
.ca-log::-webkit-scrollbar{width:4px}
.ca-log::-webkit-scrollbar-thumb{background:rgba(255,255,255,.12);border-radius:4px}
.ca-b{max-width:88%;padding:9px 13px;border-radius:13px;font-size:12.5px;line-height:1.55;white-space:pre-wrap;word-break:break-word;animation:ca-pop .18s ease}
@keyframes ca-pop{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
.ca-bb{background:#1e2a3a;color:#d8e4f5;border-radius:4px 13px 13px 13px;align-self:flex-start}
.ca-bu{background:var(--accent,#4e9af1);color:#fff;border-radius:13px 4px 13px 13px;align-self:flex-end;font-size:12px}
.ca-dot3{display:flex;gap:4px;align-items:center;padding:10px 14px;align-self:flex-start}
.ca-dot3 span{width:6px;height:6px;border-radius:50%;background:rgba(78,154,241,.7);animation:ca-bnc 1s ease infinite}
.ca-dot3 span:nth-child(2){animation-delay:.15s}
.ca-dot3 span:nth-child(3){animation-delay:.3s}
@keyframes ca-bnc{0%,60%,100%{transform:none}30%{transform:translateY(-5px)}}
.ca-acts{display:flex;flex-direction:column;gap:5px;align-self:flex-start;width:100%;max-width:88%;margin-top:2px}
.ca-ab{background:rgba(78,154,241,.1);border:1px solid rgba(78,154,241,.3);border-radius:8px;color:var(--accent,#4e9af1);font-size:11.5px;font-weight:500;padding:6px 11px;cursor:pointer;text-align:left;text-decoration:none;display:flex;align-items:center;gap:6px;transition:background .15s,border-color .15s}
.ca-ab:hover{background:rgba(78,154,241,.2);border-color:rgba(78,154,241,.55)}
.ca-cps{display:flex;flex-wrap:wrap;gap:5px;align-self:flex-start;width:100%;margin-top:4px;margin-bottom:2px}
.ca-cp{background:#1a2535;border:1px solid rgba(255,255,255,.1);border-radius:20px;color:#a8bdd6;font-size:11px;padding:4px 10px;cursor:pointer;transition:background .15s,color .15s,border-color .15s;white-space:nowrap}
.ca-cp:hover{background:rgba(78,154,241,.15);border-color:rgba(78,154,241,.4);color:#d8eaf9}
.ca-cp:disabled{opacity:.5;cursor:not-allowed}
.ca-src{display:flex;flex-direction:column;gap:6px;align-self:flex-start;width:100%;max-width:92%;margin-top:2px}
.ca-rc{background:#1a2535;border:1px solid rgba(255,255,255,.07);border-radius:10px;padding:8px 11px;cursor:pointer;transition:border-color .15s,background .15s}
.ca-rc:hover{border-color:rgba(78,154,241,.35);background:#1e2d44}
.ca-rt{font-size:12px;font-weight:600;color:#c8d9ee;margin-bottom:3px}
.ca-rb{font-size:11px;color:rgba(200,217,238,.6);white-space:pre-wrap;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.ca-ir{display:flex;align-items:center;gap:8px;padding:9px 11px;border-top:1px solid rgba(255,255,255,.07);background:#0f1623;flex-shrink:0}
.ca-in{flex:1;background:#1a2535;border:1px solid rgba(255,255,255,.1);border-radius:20px;color:#d8e4f5;font-size:12px;padding:7px 13px;outline:none;transition:border-color .15s;font-family:inherit}
.ca-in::placeholder{color:rgba(255,255,255,.25)}
.ca-in:focus{border-color:rgba(78,154,241,.45)}
.ca-snd{width:32px;height:32px;border-radius:50%;background:var(--accent,#4e9af1);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#fff;font-size:14px;flex-shrink:0;transition:background .15s,transform .12s;line-height:1}
.ca-snd:hover{background:#3a8ae0;transform:scale(1.08)}
.ca-snd:disabled{background:#2a3a4a;cursor:not-allowed;transform:none}
.ca-badge{position:absolute;top:0;right:0;width:12px;height:12px;background:#22c55e;border:2px solid #111827;border-radius:50%}
`;

let _si = false;

export default function CrunchAlphaAssistant() {
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState("id");
  const langRef = useRef("id");
  const [messages, setMessages] = useState([]);
  const [typing, setTyping] = useState(false);
  const [inputVal, setInputVal] = useState("");
  const [chipsOff, setChipsOff] = useState(false);
  const bottomRef = useRef(null);
  const inputRef = useRef(null);
  const initDone = useRef(false);

  const t = useCallback((s) => {
    if (!s) return "";
    if (typeof s === "string") return s;
    return s[langRef.current] || s.id || "";
  }, [lang]);

  useEffect(() => {
    if (_si) return;
    const el = document.createElement("style");
    el.textContent = STYLE;
    document.head.appendChild(el);
    _si = true;
  }, []);

  useEffect(() => {
    if (open) setTimeout(() => bottomRef.current?.scrollIntoView({ behavior: "smooth" }), 60);
  }, [messages, typing, open]);

  useEffect(() => {
    if (open) setTimeout(() => inputRef.current?.focus(), 200);
  }, [open]);

  const addMsg = useCallback((content, isBot = true) => {
    setMessages((p) => [...p, { id: Date.now() + Math.random(), content, isBot }]);
  }, []);

  const showNode = useCallback((nodeKey, userLabel) => {
    const node = F[nodeKey];
    if (!node) return;
    setChipsOff(true);
    if (userLabel) addMsg(userLabel, false);
    const msgs = node.msgs[langRef.current] || node.msgs.id || [];
    const arr = Array.isArray(msgs) ? msgs : [msgs];
    const base = userLabel ? 350 : 0;
    arr.forEach((txt, i) => {
      const last = i === arr.length - 1;
      setTimeout(() => {
        setTyping(true);
        setTimeout(() => {
          setTyping(false);
          addMsg({ type:"node", text:txt, actions:last?node.actions:undefined, chips:last?node.chips:undefined }, true);
          if (last) setChipsOff(false);
        }, 500);
      }, base + i * 700);
    });
  }, [addMsg, lang]);

  const switchLang = useCallback((newLang) => {
    setLang(newLang);
    langRef.current = newLang;
    setMessages([]);
    setChipsOff(false);
    initDone.current = false;
    setTimeout(() => {
      initDone.current = true;
      showNode("root");
    }, 50);
  }, [showNode]);

  useEffect(() => {
    if (initDone.current) return;
    initDone.current = true;
    setTimeout(() => showNode("root"), 400);
  }, [showNode]);

  const handleChip = useCallback((label, next) => {
    if (chipsOff) return;
    showNode(next, label);
  }, [chipsOff, showNode]);

  const handleSearch = useCallback((query) => {
    if (!query.trim()) return;
    const q = query.trim();
    setInputVal("");
    addMsg(q, false);
    const results = searchKB(q);
    setTimeout(() => {
      setTyping(true);
      setTimeout(() => {
        setTyping(false);
        if (!results.length) {
          addMsg({ type:"node", text: langRef.current==="id" ? "Hmm, saya tidak menemukan panduan untuk itu.\n\nTugas saya adalah membantu kamu menggunakan platform CrunchAlpha dengan aman — bukan memberikan saran investasi.\n\nCoba ketik topik seperti: cara kerja, risk normalization, alpharank, cara connect broker — atau pilih role kamu di bawah." : "Hmm, I couldn't find a guide for that.\n\nMy job is to help you use CrunchAlpha safely — not to give investment advice.\n\nTry typing: how it works, risk normalization, alpharank, connect broker — or select your role below.",
            chips:[
              { id:"Saya Investor", en:"I'm an Investor", next:"inv_home" },
              { id:"Saya Trader", en:"I'm a Trader", next:"tr_home" },
              { id:"Saya Analyst", en:"I'm an Analyst", next:"an_home" },
            ]}, true);
        } else {
          addMsg({ type:"search", query:q, results, lang }, true);
        }
      }, 500);
    }, 150);
  }, [addMsg, lang]);

  const handleResult = useCallback((r) => {
    addMsg(t(r.title), false);
    setTimeout(() => {
      setTyping(true);
      setTimeout(() => {
        setTyping(false);
        addMsg({ type:"node", text:t(r.body), actions:r.actions,
          chips:[{ id:"Kembali ke awal", en:"Back to start", next:"root" }]}, true);
      }, 450);
    }, 150);
  }, [addMsg, t]);

  const send = () => { if (inputVal.trim()) handleSearch(inputVal); };

  const placeholder = langRef.current === "id" ? "Ketik pertanyaan..." : "Type a question...";

  return (
    <div className="ca-widget">
      {open && (
        <div className="ca-panel" role="dialog" aria-label="CrunchAlpha Assistant">
          <div className="ca-hdr">
            <div className="ca-av">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill="#fff"/>
                <circle cx="18.5" cy="18.5" r="2" fill="#fff" opacity="0.85"/>
              </svg>
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div className="ca-hn">CrunchAlpha Assistant</div>
              <div className="ca-hs">{langRef.current==="id" ? "Siap membantu kamu" : "Here to help you"}</div>
            </div>
            <div className="ca-lang">
              <button className={lang==="id"?"active":""} onClick={() => switchLang("id")}>ID</button>
              <button className={lang==="en"?"active":""} onClick={() => switchLang("en")}>EN</button>
            </div>
            <button className="ca-hx" onClick={() => setOpen(false)} aria-label="Close">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </button>
          </div>

          <div className="ca-log" role="log" aria-live="polite">
            {messages.map((m) => {
              if (!m.isBot) return <div key={m.id} className="ca-b ca-bu">{typeof m.content==="string"?m.content:m.content?.text||""}</div>;
              if (m.content?.type==="search") return (
                <div key={m.id}>
                  <div className="ca-b ca-bb">{langRef.current==="id"?`Saya temukan ${m.content.results.length} hasil untuk "${m.content.query}":`:`Found ${m.content.results.length} result(s) for "${m.content.query}":`}</div>
                  <div className="ca-src">
                    {m.content.results.map((r,ri) => (
                      <div key={ri} className="ca-rc" onClick={()=>handleResult(r)} role="button" tabIndex={0} onKeyDown={(e)=>e.key==="Enter"&&handleResult(r)}>
                        <div className="ca-rt">{t(r.title)}</div>
                        <div className="ca-rb">{t(r.body)}</div>
                      </div>
                    ))}
                  </div>
                </div>
              );
              const c = m.content;
              const text = typeof c==="string"?c:c?.text||"";
              return (
                <div key={m.id}>
                  {text && <div className="ca-b ca-bb">{text}</div>}
                  {c?.actions?.length>0 && (
                    <div className="ca-acts">
                      {c.actions.map((a,ai) => <a key={ai} href={a.href} className="ca-ab">↗ {t(a.label)}</a>)}
                    </div>
                  )}
                  {c?.chips?.length>0 && (
                    <div className="ca-cps">
                      {c.chips.map((ch,ci) => (
                        <button key={ci} className="ca-cp" onClick={()=>handleChip(t(ch),ch.next)} disabled={chipsOff}>{t(ch)}</button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
            {typing && <div className="ca-b ca-bb ca-dot3"><span/><span/><span/></div>}
            <div ref={bottomRef}/>
          </div>

          <div className="ca-ir">
            <input ref={inputRef} className="ca-in" type="text" placeholder={placeholder} value={inputVal}
              onChange={(e)=>setInputVal(e.target.value)} onKeyDown={(e)=>e.key==="Enter"&&send()} aria-label={placeholder}/>
            <button className="ca-snd" onClick={send} disabled={!inputVal.trim()} aria-label="Send">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13"/><path d="M22 2L15 22l-4-9-9-4 20-7z"/></svg>
            </button>
          </div>
        </div>
      )}
      <div style={{position:"relative",display:"inline-block"}}>
        <button className="ca-fab" onClick={()=>setOpen(v=>!v)} aria-label={open?"Close":"Open assistant"} aria-expanded={open}>
          {open ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 6.5A2.5 2.5 0 016.5 4h11A2.5 2.5 0 0120 6.5v7A2.5 2.5 0 0117.5 16H9l-4 3.5V6.5z" fill="#fff"/>
              <circle cx="9" cy="10" r="1.1" fill="#2563EB"/>
              <circle cx="12" cy="10" r="1.1" fill="#2563EB"/>
              <circle cx="15" cy="10" r="1.1" fill="#2563EB"/>
            </svg>
          )}
        </button>
        {!open && <div className="ca-badge" aria-hidden="true"/>}
      </div>
    </div>
  );
}
